import { useEffect, useState } from 'react';
import { getDelegationLadder, type DelegationLadder } from '@/lib/delegation';

/** The workspace's ladder, seven until it says otherwise. */
export function useDelegationLadder(workspaceId: string | null | undefined): DelegationLadder {
  const [ladder, setLadder] = useState<DelegationLadder>('seven');
  useEffect(() => {
    let live = true;
    if (!workspaceId) return undefined;
    getDelegationLadder(workspaceId).then((l) => { if (live) setLadder(l); }).catch(() => { /* seven stands */ });
    return () => { live = false; };
  }, [workspaceId]);
  return ladder;
}
